import { Product } from './product';

export class Menu {
    data: Product[];
    sequence: any[];

    constructor(
        data: Product[] = [],
        sequence: any[] = []
    ) {
        this.data = data;
        this.sequence = sequence;
    }
}
